module.exports = __webpack_public_path__ + "static/img/fluoro3.92a502db.png";